var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-checkbox-list",class:_vm.inputClass},_vm._l((_vm.checkboxes),function(value,key){return _c('label',{key:key,staticClass:"m-checkbox"},[_c('input',{attrs:{"type":"checkbox","name":'name['+key+']'},domProps:{"value":key}}),_vm._v("\n        "+_vm._s(value)+"\n        "),_c('span')])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a5bd710","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/form/inputs/CheckboxComponent.vue
// module id = null
// module chunks = 